import React from 'react';
import PropTypes from 'prop-types';


const Spinner = ({styles}) => (
    <div className="spinner spinner-box" style={styles}>
        <div className="spinner-cube" />
    </div>
);

Spinner.defaultProps = {
    styles: {
        height: '100%'
    }
};

Spinner.propTypes = {
    styles: PropTypes.shape({height: PropTypes.string})
};

export default Spinner;
